import React from 'react';
import { useTranslation } from 'react-i18next';
import {Link as RouterLink} from "react-router-dom";
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import Link from '@mui/material/Link';

export default function CategoryImageLink(props) {
  const { t } = useTranslation('categoryLabel');
  let label = t("categoryLabel:" + props.labelKey)

  return (
    <Link component={RouterLink} to={props.id} >
      <ImageListItem key={props.tnUrl} sx={{mb:{xs:3,sm:5}}}>
        <img
          src={`${props.tnUrl}`}
          alt={label}
          loading="lazy"
          width={300}
          height={300}
        />
        <ImageListItemBar
          title={label}
          position="top"
        />
      </ImageListItem>
    </Link>
  )
}
